export default __webpack_public_path__ + "static/media/img--boardwalk-1.5eedefd6.jpg";